import { api } from '../api';
import { VPN_PROBE_URL } from '../../constants/vpn';

export const vpnSlice = api.injectEndpoints({
  endpoints: (build) => ({
    /**
     * Asked for its status code, never its data: a 406 raises the VPN notice
     * from the API layer, and anything else means the IP is allowed. Not kept
     * in the cache, so every probe goes to the network.
     */
    vpnProbe: build.query<unknown, { preventSnackbar?: boolean }>({
      query: () => ({ url: VPN_PROBE_URL }),
      keepUnusedDataFor: 0
    })
  }),
  overrideExisting: false
});

export const { useLazyVpnProbeQuery } = vpnSlice;
